// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M5.8 4L8 1.8L10.2 4M8 1.8V6.2',
  'M5.3 11.5C5.3 10.01 6.51 8.8 8 8.8C9.49 8.8 10.7 10.01 10.7 11.5',
  'M1.5 11.5H2.8M13.2 11.5H14.5',
  'M3.44 6.94L4.39 7.89M11.61 7.89L12.56 6.94',
  'M1.5 14H14.5',
];
